const serverValidation = {
  createMixin() {
    return {
      data() {
        return {
          server_errors: {},
        };
      },
      methods: {
        addServerError(type) {
          this.server_errors[type] = true;
        },
        clearServerErrors() {
          this.server_errors = {};
        },
      },
    };
  },
  validator(name) {
    return (_value, vm) => !_.get(vm.server_errors, name, false);
  },
};

export default serverValidation;
